"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCombinedReducer = createCombinedReducer;

var _redux = require("redux");

var _createLeafReducer = require("./create-leaf-reducer");

var _createSliceHelper = require("./create-slice-helper");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createCombinedReducer(parentSliceHelper, sliceName) {
  var initialSlice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var sliceHelper = (0, _createSliceHelper.createSliceHelper)(parentSliceHelper, sliceName, initialSlice);
  var subReducers = {};

  var combinedReducer = function combinedReducer(slice) {
    return slice;
  };

  var combineSubReducer = function combineSubReducer(subReducer) {
    var subSliceName = subReducer.sliceName;

    if (!subSliceName) {
      throw new Error("SubReducer must have a sliceName");
    }

    if (subReducers[subSliceName]) {
      throw new Error("SubReducer '".concat(subSliceName, "' already exists in '").concat(sliceName, "' SliceReducer"));
    }

    subReducers = _objectSpread({}, subReducers, _defineProperty({}, subSliceName, subReducer));
    combinedReducer = (0, _redux.combineReducers)(subReducers);
  };

  var newCombinedReducer = function newCombinedReducer(subSliceName, subInitialState) {
    var combinedSubReducer = createCombinedReducer(sliceHelper, subSliceName, subInitialState);
    combineSubReducer(combinedSubReducer);
    return combinedSubReducer;
  };

  var newLeafReducer = function newLeafReducer(subSliceName, subInitialState) {
    var leafSubReducer = (0, _createLeafReducer.createLeafReducer)(sliceHelper, subSliceName, subInitialState);
    combineSubReducer(leafSubReducer);
    return leafSubReducer;
  };

  var reducer = function reducer() {
    var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSlice;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return combinedReducer(slice, action);
  };

  return Object.assign(reducer, _objectSpread({
    newCombinedReducer: newCombinedReducer,
    newLeafReducer: newLeafReducer
  }, sliceHelper));
}